import { Main } from '@pages/eurasia36/Main';
import { CardInfo } from '@pages/eurasia36/CardInfo';
import {
  eurasia36Pay,
  eurasia36PayFailed,
  eurasia36PaySuccess
} from '@root/constants/paths';
import CustomSuccess from '@root/components/CustomSuccess';
import CustomFailed from '@root/components/CustomFailed';
import { formPayData, getEurasia36ContentData } from '@root/constants/formData';

const { main } = getEurasia36ContentData();

export const getEurasia36PayRoutes = () => [
  {
    path: eurasia36Pay(),
    element: (
      <Main
        mainContent={main}
        formData={formPayData}
        redirectPaths={{
          success: eurasia36PaySuccess,
          failed: eurasia36PayFailed
        }}
      >
        <CardInfo userData={undefined as never} />
      </Main>
    )
  },
  {
    path: eurasia36PaySuccess(),
    element: <CustomSuccess />
  },
  {
    path: eurasia36PayFailed(),
    element: <CustomFailed />
  }
];
